"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusFilterMenuHeader = StatusFilterMenuHeader;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
/**
 * Pasek filtra statusów renderowany JAKO NAGŁÓWEK w menu selektora
 * (react-bootstrap-typeahead `renderMenu`). Widoczny od razu po otwarciu selektora —
 * nie wymaga klikania osobnego przycisku. Statusy działają jak przełączniki (multi-select):
 * kliknięcie pigułki dodaje/usuwa status z filtra.
 *
 * `onMouseDown` preventDefault na kontenerze utrzymuje focus w polu (menu nie zamyka się
 * przy kliknięciu), a `stopPropagation` na kliknięciu pigułki zapobiega wyborowi opcji.
 */
function StatusFilterMenuHeader({ allStatuses, selectedStatuses, onChange, }) {
    function toggleStatus(status) {
        onChange(selectedStatuses.includes(status)
            ? selectedStatuses.filter((s) => s !== status)
            : [...selectedStatuses, status]);
    }
    return (react_1.default.createElement("div", { className: "px-3 py-2 border-bottom position-sticky top-0 d-flex align-items-center gap-2 flex-wrap", style: { zIndex: 5, backgroundColor: "var(--bs-tertiary-bg, #f8f9fa)" }, onMouseDown: (e) => e.preventDefault() },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFilter, className: "text-muted", size: "sm" }),
        react_1.default.createElement("span", { className: "small text-muted me-1" }, "Statusy:"),
        allStatuses.map((status) => {
            const active = selectedStatuses.includes(status);
            return (react_1.default.createElement(react_bootstrap_1.Badge, { key: status, bg: active ? "primary" : "light", text: active ? "light" : "dark", className: "border", role: "button", title: active ? "Kliknij, aby ukryć" : "Kliknij, aby pokazać", onClick: (e) => {
                    e.stopPropagation();
                    toggleStatus(status);
                } },
                active ? "✓ " : "",
                status));
        })));
}
